/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.19/esri/copyright.txt for details.
*/
import{TILE_SIZE as s}from"./definitions.js";import{TiledDisplayObject as o}from"./TiledDisplayObject.js";class r extends o{constructor(o,r){super(o,r,[s,s])}}export{r as WGLTile};
